import { ReactComponent as OptInSvg } from './svg/resolve.svg'

const ResolveIcon = ({ fill = '#FFFFFF', ...props }) => (
  <OptInSvg fill={fill} {...props} />
)

export default ResolveIcon
